exports.components = {
  "component---src-pages-search-tsx": () => import("./../../../src/pages/search.tsx" /* webpackChunkName: "component---src-pages-search-tsx" */),
  "component---src-templates-data-data-tsx": () => import("./../../../src/templates/data/Data.tsx" /* webpackChunkName: "component---src-templates-data-data-tsx" */)
}

